<script>
import shopProductOptions from '@/v-shop/mixins/shop-product-options-mixin'
export default {
	mixins: [shopProductOptions],
	props: {
		product: Object,
		selectedVariant: Object,
	},
	computed: {
		marketplaceMode() {
			return process.env.VUE_APP_MARKETPLACE_MODE
		},
		showSeller() {
			let sellerId = this.$srv('sellerInfo.sellerId', [])
			return sellerId.some((id) => id == this.product.seller.id)
		},
	},
}
</script>

<template>
	<div>
		<div class="d-flex align-center" style="gap: 10px">
			<div>
				<SafeLink
					v-if="product.brand && !spoHideBrand"
					:to="$shop.getShopRoute({ brand: product.brand.urlName })"
				>
					Marca:
					<span class="font-weight-bold nowrap">{{ product.brand.name }}</span>
				</SafeLink>
			</div>
			<div v-if="!spoHideSku">
				Sku: <span class="font-weight-bold">{{ selectedVariant.sku }}</span>
			</div>
			<div v-if="!spoHideEan && selectedVariant.ean">
				Ean: <span class="font-weight-bold">{{ selectedVariant.ean }}</span>
			</div>
		</div>
		<div class="my-2" v-if="marketplaceMode && showSeller && !spoHideSeller">
			<div v-if="product.seller.logo" style="height: 20px" class="mt-2 mb-1">
				<Media :src="product.seller.logo" height="20px" max-width="130px" position="left" />
			</div>
			<div>
				Producto vendido por
				<span class="font-weight-bold">{{ product.seller.name.toUpperCase() }}</span>
			</div>
		</div>
	</div>
</template>

